export const API_BASE_URL = 'http://localhost:30002/api/v1';
export const STRIPE_PUBLISHABLE_KEY = 'pk_test_51Rna4xQSx32nAutiODxDk79GfYyo6WjQedXihtqLfhFSW2ty2XN6lwfEZxvickbaPSfGoPxdcV7CwlQGNpzv68km00ddnqfS8X';

export const PAYMENT_STATUS = {
  INITIALIZED: 'initialized',
  SUCCESS: 'success',
  FAILED: 'failed',
  REFUNDED: 'refunded'
};

export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled'
};